const base = {
    bg: 'transparent',
    border: 'none',
    color: 'darkBlue.main'
};
const baseStyle = {
    button: {
        ...base,
        color: 'seaBlue.main',
        hoverBg: 'skyBlue.main',
        minW: 24
    },
    ellipsis: { ...base },
    goToPage: { ...base },
    prevNext: {
        ...base
    },
    results: {
        color: 'sandstone.30'
    }
};
const defaultProps = {};
const parts = ['container', 'button', 'ellipsis', 'goToPage', 'navigation', 'prevNext', 'results'];
const sizes = {};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
